import { addDays, parseISO } from 'date-fns';
import { Subscription, SubscriptionStatus } from '~/types/subscriptions';
import { sortAlphabetically } from './sort';

export const getCurrentSubscription = (subscriptions?: Subscription[]): Subscription | undefined => {
  if (!subscriptions) return undefined;

  const orderedSubscription = subscriptions.sort((a, b) => sortAlphabetically(a.createdAt, b.createdAt));
  const result = orderedSubscription.reduce<{
    activeSubscription?: Subscription;
    pastDueSubscription?: Subscription;
    incompleteSubscription?: Subscription;
    unpaidSubscription?: Subscription;
    canceledSubscription?: Subscription;
  }>((acc, el) => {
    if (el.status === SubscriptionStatus.Canceled) acc.canceledSubscription = el;
    else if (el.status === SubscriptionStatus.Incomplete) acc.incompleteSubscription = el;
    else if (el.status === SubscriptionStatus.PastDue) acc.pastDueSubscription = el;
    else if (el.status === SubscriptionStatus.Unpaid) acc.unpaidSubscription = el;
    else if (acc.activeSubscription?.status !== SubscriptionStatus.Active) {
      acc.activeSubscription = el;
    }
    return acc;
  }, {});

  return (
    result.activeSubscription ||
    result.pastDueSubscription ||
    result.unpaidSubscription ||
    result.incompleteSubscription ||
    result.canceledSubscription
  );
};

export const getTrialExpirationDate = (subscription: Subscription): Date | null => {
  if (
    subscription.status !== SubscriptionStatus.Trial &&
    subscription.status !== SubscriptionStatus.TrialWillEnd &&
    subscription.status !== SubscriptionStatus.TrialWithPaymentMethod
  )
    return null;
  const creationDate = parseISO(subscription.createdAt);
  return addDays(creationDate, 7);
};
